'use strict';

var Sugar = require('sugar-core'),
    objectExclude = require('./internal/objectExclude');

Sugar.Object.defineInstanceAndStatic({

  'exclude': function(obj, f) {
    return objectExclude(obj, f);
  }

});

module.exports = Sugar.Object.exclude;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/exclude.js
// module id = 773
// module chunks = 0